/*
    Created by Phat Pham
    phat@launchdeck.org
*/

import React, { Component } from 'react';
import {
    Text,
    View,
    Image,
    TouchableOpacity
} from 'react-native-web';
import propTypes from 'prop-types';
import Icon from 'react-native-vector-icons/MaterialIcons';

// Global Variables Import
import GLOBAL from '../configs/config_global';
import SIZE from '../configs/config_size';

// Root Navigation
import * as RootNavigation from '../navigation/RootNavigation';

export class NavBar extends Component {
    // region Props
    static propTypes = {
        title: propTypes.string,
        extraTitle: propTypes.string,
        extraTitleColor: propTypes.string,
        subTitle: propTypes.string,
        leftButtonTitle: propTypes.string,
        rightButtonTitle: propTypes.string,
        leftButtonOnPress: propTypes.func,
        rightButtonOnPress: propTypes.func,

        leftButtonIconName: propTypes.string,
        leftButtonIconSize: propTypes.number,
        leftButtonIconColor: propTypes.string,

        rightButtonBackgroundColor: propTypes.string,
        rightButtonColor: propTypes.string,
        rightButtonIconName: propTypes.any,
        rightButtonIconSize: propTypes.number,
        horizontalSpacing: propTypes.number,
        iconSize: propTypes.number,
        hideBorder: propTypes.bool,

        isAbsolute: propTypes.bool,
        isInsideSheet: propTypes.bool,

        titleStickToLeft: propTypes.bool,
        titleOnPress: propTypes.func
    };

    static defaultProps = {
        title: '',
        extraTitle: '',
        extraTitleColor: GLOBAL.COLOR.BASIC.BLACK_TWO,
        subTitle: '',
        leftButtonTitle: '',
        rightButtonTitle: '',
        leftButtonOnPress: () => RootNavigation.goBack(),
        leftButtonIconName: 'close',
        leftButtonIconColor: GLOBAL.COLOR.BASIC.BLACK_TWO,
        horizontalSpacing: 16,
        iconSize: 32,
        hideBorder: false,
        rightButtonBackgroundColor: GLOBAL.COLOR.BASIC.UI_BLUE,
        rightButtonColor: 'white',
        isAbsolute: false,
        isInsideSheet: false,
        titleStickToLeft: false,
        titleOnPress: null
    };
    // endregion

    // region Constructor
    constructor(props) {
        super(props);
        this.state = {

        };

        this.contentSize = SIZE.NAV_BAR_HEIGHT + (this.props.subTitle?.trim() ? 8 :0);
    }
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            horizontalSpacing,
            iconSize,
            leftButtonIconColor,
            leftButtonIconSize,
            leftButtonIconName,
            leftButtonTitle,
            leftButtonOnPress,
            rightButtonIconSize,
            hideBorder,
            isAbsolute,
            titleStickToLeft,
            rightButtonTitle,
            rightButtonIconName,
            rightButtonBackgroundColor,
            rightButtonColor,
            rightButtonOnPress,
            title,
            extraTitle,
            extraTitleColor,
            titleOnPress
        } = this.props;

        const topBarHeight = 0;
        const TitleComp = titleOnPress ? TouchableOpacity : View;

        return(
            <View style={[
                {
                    width: '100%', height: topBarHeight + this.contentSize,
                    flexDirection: 'row', alignItems: 'center', paddingTop: topBarHeight,
                    backgroundColor: 'white',
                    paddingHorizontal: horizontalSpacing
                },
                !hideBorder && { borderBottomWidth: 1, borderColor: GLOBAL.COLOR.DIVIDER },
                isAbsolute && { position: 'absolute', left: 0, right: 0, top: 0 },
                this.props.style
            ]}>
                {/* Left Icon */}
                {
                    !!leftButtonOnPress &&
                    <TouchableOpacity
                        onPress={leftButtonOnPress}
                        style={{ width: this.contentSize - (titleStickToLeft ? 12 : 0), height: this.contentSize, alignItems: 'flex-start', justifyContent: 'center' }}>
                        {
                            leftButtonTitle?.trim() ?
                                <Text style={{ fontSize: 18, fontWeight: '600', color: GLOBAL.COLOR.BASIC.WARM_GREY, width: this.contentSize, textAlign: 'left', marginLeft: this.props.leftButtonIconName ? 2 : 0 }}>
                                    {leftButtonTitle}
                                </Text>
                                :
                                (
                                    leftButtonIconName?.trim() ?
                                        <Icon
                                            name={leftButtonIconName}
                                            size={leftButtonIconSize || iconSize}
                                            color={leftButtonIconColor}
                                        />
                                        :
                                        null
                                )
                        }
                    </TouchableOpacity>
                }

                {/* Title and Subtitle */}
                <TitleComp onPress={titleOnPress} style={{ flex: 1, alignItems: titleStickToLeft ? 'flex-start' : 'center', justifyContent: 'center' }}>
                    {/* Title */}
                    <Text
                        style={{ color: GLOBAL.COLOR.BASIC.BLACK_TWO, fontWeight: 'bold', textAlign: titleStickToLeft ? 'left' : 'center' }}
                        numberOfLines={1}>
                        {title}
                        {
                            !!extraTitle &&
                            <Text style={{ color: extraTitleColor, fontWeight: 'bold' }}>
                                {extraTitle}
                            </Text>
                        }
                    </Text>

                    {/* Subtitle */}
                    {
                        this.props.subTitle ?
                            <Text style={{ color: GLOBAL.COLOR.BASIC.WARM_GREY, textAlign: 'center', fontSize: 14, marginTop: 6 }} numberOfLines={1}>
                                {this.props.subTitle}
                            </Text>
                            :
                            <View/>
                    }
                </TitleComp>

                {/* Right Button */}
                {
                    (rightButtonTitle || rightButtonIconName) ?
                        <TouchableOpacity
                            onPress={rightButtonOnPress}
                            style={{ width: rightButtonTitle ? 'auto' : this.contentSize, height: this.contentSize, alignItems: 'flex-end', justifyContent: 'center' }}>
                            {
                                rightButtonTitle ?
                                    <View style={{ backgroundColor: rightButtonBackgroundColor, borderRadius: 6, paddingHorizontal: 24, paddingVertical: 12 }}>
                                        <Text style={{ fontSize: 16, fontWeight: 'bold', color: rightButtonColor, textAlign: 'right' }}>
                                            {rightButtonTitle}
                                        </Text>
                                    </View>
                                    :
                                    (
                                        this.props.rightButtonIconName ?
                                            (
                                                typeof this.props.rightButtonIconName === 'string' ?
                                                    <Icon
                                                        name={this.props.rightButtonIconName}
                                                        size={rightButtonIconSize || iconSize}
                                                        color={rightButtonColor || GLOBAL.COLOR.BASIC.BLACK_TWO}
                                                    />
                                                    :
                                                    <Image
                                                        source={this.props.rightButtonIconName}
                                                        style={{ width: this.props.iconSize, height: this.props.iconSize, tintColor: this.props.rightButtonColor }}
                                                    />
                                            )
                                            :
                                            null
                                    )
                            }
                        </TouchableOpacity>
                        :
                        <View style={{ width: this.contentSize, height: this.contentSize }}/>
                }
            </View>
        );
    }
    // endregion
}
